import { getSidePanelDeepLink } from 'common/components/Layout/OfficeShellPanel/getSidePanelDeepLink';
import { OfficeShellPanelState } from 'common/components/Layout/OfficeShellPanel/OfficeShellPanel.types';
import { ISnackBarActionProps, SnackbarType } from 'common/components/Notifications';
import {
  getScreenHeight,
  getScreenMode,
  getScreenSize,
  ScreenHeight,
  ScreenMode,
  ScreenSize,
} from 'common/utilities/ResponsiveBreakpoints';

/**
 * Global notifications
 */
export const enum NotificationType {
  Toast,
}

/**
 * Global notifications
 */
export interface INotification {
  /**
   * Whether the notification should have a dismiss button.
   */
  dismissable?: boolean;
  /**
   * Timeout in millisecs. Notification will be dismissed after this timeout.
   * If its set to 0, notification will not be automatically dismissed and rely on manual dismiss by user.
   *
   * @default 3000ms
   */
  dismissDelayInMs?: number;
  /**
   * If `hideIcon` is set to `true`, then no icon will be displayed
   * in the the notification.
   *
   * @default false
   */
  hideIcon?: boolean;
  /**
   * Unique id for the notification.
   */
  id: string;
  /**
   * Notification message.
   */
  message: string;
  /**
   * @default SnackbarType.info
   */
  messageType?: SnackbarType;
  /**
   * Global notification type.
   */
  type: NotificationType;
  /**
   * Optional actions. Max of 2 will be shown.
   */
  actions?: ISnackBarActionProps[];
}

export interface ILayoutState {
  /**
   * Screen height type
   */
  screenHeight: ScreenHeight;

  /**
   * Screen size type (width)
   */
  screenSize: ScreenSize;

  /**
   * Screen mode type
   */
  screenMode: ScreenMode;

  /**
   * Indicates if site navigation is presented
   */
  isNavigationVisible: boolean;

  /**
   * Indicates if office shell panel is presented
   */
  officeShellPanel: OfficeShellPanelState | undefined;

  /**
   * Stores global messages
   */
  notifications: INotification[];

  /**
   * Indicates if background is blurry or not
   */
  isBlurryBackground: boolean;

  /**
   * Whether to use a custom scrollbar style or not
   */
  useCustomScrollBar: boolean;
}

export function getDefaultLayoutState(): ILayoutState {
  const officeShellPanel = getSidePanelDeepLink();

  return {
    screenHeight: getScreenHeight(),
    screenSize: getScreenSize(),
    screenMode: getScreenMode(),
    isNavigationVisible: true,
    officeShellPanel,
    notifications: [],
    isBlurryBackground: false,
    useCustomScrollBar: false,
  };
}
